import Auth from '@/services/Rest/Auth';
import router from '@/router';

export default {
	state: {
		loggedIn: Boolean(localStorage.getItem('user')),
		user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
		resetPasswordRequestSent: localStorage.getItem('rprSent') ? JSON.parse(localStorage.getItem('rprSent')) : {},
		logoutMessage: localStorage.getItem('logoutMessage') ? localStorage.getItem('logoutMessage') : ''
	},

	mutations: {
		loginSuccess(state, data) {
			localStorage.setItem('accessToken', data.access_token);
			localStorage.setItem('refreshToken', data.refresh_token);
			localStorage.setItem('expiresIn', data.expires_in);
			localStorage.removeItem('logoutMessage');
		},

		logout(state, logoutMessage) {
			state.loggedIn = false;
			state.user = {};
			localStorage.setItem('logoutMessage', logoutMessage);
			localStorage.removeItem('accessToken');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('expiresIn');
			localStorage.removeItem('user');
			location.reload();
		},
		setUser(state, user) {
			state.user = user;
			state.loggedIn = true;
			localStorage.setItem('user', JSON.stringify(user));
		},

		updateUserAccount(state, user) {
			state.user = user;
			localStorage.setItem('user', JSON.stringify(user));
		}
	},

	actions: {
		login({ commit, dispatch }, { email, password }) {
			return Auth.login(email, password).then(
				response => {
					commit('loginSuccess', response.data);
					dispatch('fetchUser', { commit, dispatch }).then((response) => {
						const link = ['admin', 'super_admin'].includes(response.data.role)
							? '/admin/properties'
							: '/landing';

						router.push(link);
					});

					return Promise.resolve(response);
				}
			);
		},

		logout({ commit }, message = '') {
			commit('logout', message);
			router.push('/login');
		},

		fetchUser({ commit, dispatch }) {
			return Auth.user().then(
				response => {
					commit('setUser', response.data);

					return Promise.resolve(response);
				},
				(error) => {
					dispatch('logout');

					return Promise.reject(error);
				}
			);
		},

		refreshToken({ commit }) {
			return Auth.refreshToken().then(response => {
				commit('loginSuccess', response.data);

				return Promise.resolve(response.data.access_token);
			});
		},

		sendResetPasswordRequest({ commit, dispatch }, email) {
			return Auth.resetPasswordRequest(email);
		},

		testResetPasswordToken({ commit, dispatch }, { token, email }) {
			return Auth.testResetPasswordToken(token, email);
		},

		resetPassword({ commit, dispatch }, { token, email, password }) {
			return Auth.resetPassword(token, email, password);
		}
	},

	getters: {
		getUser(state) {
			return state.user;
		},

		getLoggedIn(state) {
			return state.loggedIn;
		},
		getLogoutMessage(state) {
			return state.logoutMessage;
		}
	}
};
